import * as React from 'react';
import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

type Props = {
    items: any,
    controller: string
    state?: any
}

export default (props: Props) => {
    return (
        <>
            <DataList {...props} modalController={props.controller}>
                <DataColumn kid='column2' name='Descrizione' fieldName='description' minWidth={200} align='left' />
                <DataColumn kid='columnDL' name='' fieldName='' minWidth={10} maxWidth={10} align='center' type='download' />
            </DataList>
        </>
    );
}
